import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProductQuoteComponent } from './product-quote/product-quote.component';
import { QuoteDataCaptureService, ApplicationDataCaptureService } from '../../../../shared';

@Injectable({
  providedIn: 'root'
})
export class CreateQuoteSubmittedCanDeativeGuard implements CanDeactivate<ProductQuoteComponent>  {
  constructor(private applicationDataService: ApplicationDataCaptureService,
              private router: Router) {}
canDeactivate(component: ProductQuoteComponent): boolean {
  if (component.allowtogoNextpage) {
   // this.applicationDataService.setBackClicked(false);
    // return this.router.navigate['/quote/your-saved-quotes'];
   // history.pushState(null, null, location.href);
    return true;
  } else {
    return false;
   // return !!this.router.navigate['/quote/your-saved-quotes'];
  }
}
}
